export default __webpack_public_path__ + "static/media/deliveries_2.49f9e410.png";